import api from "../api";
import {ElMessage} from "element-plus";

export default {
    namespaced: true,

    state: {
        tenant: {
            lease: {}
        },
        tenants_by_day: [],
        tenants_by_county: [],
        summary: {
            total_transaction_data: {
                amount: 0.00,
                transactions: 0
            },
            admin_transaction_data: {
                amount: 0.00,
                transactions: 0
            },
            realtor_transaction_data: {
                amount: 0.00,
                transactions: 0
            },
            payments_graph: []
        },
        profile_completeness: 0,
        tenant_documents: [],
        setTenant: [],
        user_tenant: [],
        tenants: {data: [], current_page: 1, total: 0, per_page: 10},
        dashboard_summary: {},
        tps_dashboard_summary: {},
        tenant_tenancies: {},
        loading: false,
        errors: {
            data: {
                errors: {
                    first_name: [],
                    last_name: [],
                    email: [],
                    id_number: [],
                    phone: [],
                    phone_2: [],
                    pin_number: [],
                    active: [],
                    tenant_type_id: [],
                    county_id: [],
                    country_id: [],
                    gender_id: [],
                    date_of_birth: [],
                    passport_photo: [],
                    disabled: [],
                    user_id: [],
                    profile_completeness: [],
                    otp: [],
                    marital_status_id: [],
                    no_of_dependants: [],
                    salary_range_id: [],
                    occupation_id: [],
                    employment_status_id: [],
                    income_stream_id: [],
                    employer_type_id: [],
                    platform_id: [],
                    next_of_kins: [],
                    county_of_birth_id: []
                }
            }
        },
        has_errors: false,
    },
    getters: {
        tenant_tenancies: state => state.tenant_tenancies,
        tps_dashboard_summary: state => state.tps_dashboard_summary,
        tenants_by_county: state => state.tenants_by_county,
        tenants_by_day: state => state.tenants_by_day,
        tenant_documents: state => state.tenant_documents,
        loading: state => state.loading,
        setTenant: state => state.setTenant,
        user_tenant: state => state.user_tenant,
        tenants: state => state.tenants,
        errors: state => state.errors,
        has_errors: state => state.has_errors,
        profile_completeness: state => state.profile_completeness,
        summary: state => state.summary,
        dashboard_summary: state => state.dashboard_summary,
        tenant: state => state.tenant
    },
    mutations: {
        setTenantTpsDashboardSummary(state, data) {
            state.tps_dashboard_summary = data
        },
        setTenantTenancies(state, data) {
            state.tenant_tenancies = data
        },
        setTenantDashboardSummary(state, data) {
            state.dashboard_summary = data
        },
        setTenantsByDay(state, data) {
            state.tenants_by_day = data
        },
        setTenantsByCounty(state, data) {
            state.tenants_by_county = data
        },
        setTenantSummary(state, data) {
            state.summary = data;
        },
        setTenantProfileCompleteness(state, data) {
            state.profile_completeness = data
        },
        setTenantDocuments(state, data) {
            state.tenant_documents = data
        },
        setLoading(state, val) {
            state.loading = val
        },
        setTenants(state, data) {
            state.tenants = data;
        },
        setTenant(state, data) {
            state.tenant = data;
        },
        setErrors(state, errors) {
            state.errors = errors
        },
        hasErrors(state, val) {
            state.has_errors = val
            if (!val) {
                state.errors = {
                    data: {
                        errors: {
                            first_name: [],
                            last_name: [],
                            email: [],
                            id_number: [],
                            phone: [],
                            phone_2: [],
                            pin_number: [],
                            active: [],
                            tenant_type_id: [],
                            county_id: [],
                            country_id: [],
                            gender_id: [],
                            date_of_birth: [],
                            passport_photo: [],
                            disabled: [],
                            user_id: [],
                            profile_completeness: [],
                            otp: [],
                            marital_status_id: [],
                            no_of_dependants: [],
                            salary_range_id: [],
                            occupation_id: [],
                            employment_status_id: [],
                            income_stream_id: [],
                            employer_type_id: [],
                            platform_id: [],
                            county_of_birth_id: []
                        }
                    }
                };
            }
        }
    },
    actions: {
        async getTenantsByCounty({commit}) {
            try {
                const response = await api.getTenantsByCounty();
                commit('setTenantsByCounty', response);
            } catch (e) {
                commit('deactivateLoading', 'setTenant/list', {root: true});
                ElMessage.error(e.response.data.message);
            }
        },
        async getTenantsByDay({commit}) {
            try {
                const response = await api.getTenantsByDay();
                commit('setTenantsByDay', response);
            } catch (e) {
                commit('deactivateLoading', 'setTenant/list', {root: true});
                ElMessage.error(e.response.data.message);
            }
        },
        async getTenantDashboardSummary({commit}) {
            try {
                const response = await api.getTenantDashboardSummary()
                commit('setTenantDashboardSummary', response.data)
            } catch (e) {
                ElMessage.error("There was an issue getting setTenant dashboard summary");
            }
        },
        async getTenantSummary({commit}, data) {
            try {
                const response = await api.getTenantDashboardSummary(data)
                commit('setTenantSummary', response.data)
            } catch (e) {
                ElMessage.error("There was an issue getting setTenant summary");
            }
        },
        async getTenantProfileCompleteness({commit}, setTenant) {
            try {
                const response = await api.getTenantProfileCompleteness(setTenant);
                commit('setTenantProfileCompleteness', response.data)
            } catch (e) {
                ElMessage.error("There was an error getting profile completeness. Please try again later.")
            }
        },
        async getTenantDocuments({commit}) {
            try {
                const response = await api.getTenantDocuments();
                commit('setTenantDocuments', response.data)
            } catch (e) {
                ElMessage.error("There was an error getting documents. Please try again later.")
            }
        },
        async deleteDocument({commit, dispatch}, data) {
            try {
                const response = await api.deleteDocument(data);
                ElMessage.success("Document removed successfully.")
                window.location.reload()
            } catch (e) {
                ElMessage.error("There was an error deleting this document. Please try again later.")
            }
        },
        async getUserTenant({commit}, user_id) {
            try {
                const response = await api.getUserTenant(user_id);
                commit('setTenant', response.data)
            } catch (e) {
                commit("setLoading", false);
            }
        },
        async getTenant({commit}, tenant_id) {
            try {
                const response = await api.getTenant(tenant_id);
                commit('setTenant', response.data)
            } catch (e) {
                ElMessage.error("")
            }
        },
        async searchTenant({commit}, id_number) {
            try {
                const response = await api.searchTenant(id_number);
                commit('setTenant', response.data)
                console.log(response?.data)
                ElMessage.success({
                    'message': 'Request populated successfully.'
                })
            } catch (e) {
                ElMessage.error({
                    'message': 'Unable to process your request.'
                })
            }
        },
        async getTenants({commit}, filters) {
            try {
                commit('setLoading', true)
                commit('activateLoading', 'setTenant/list', {root: true});
                const response = await api.getTenants(filters);
                commit('setTenants', response);
                commit('setLoading', false)
                commit('deactivateLoading', 'setTenant/list', {root: true});
            } catch (e) {
                commit('setLoading', false)
                ElMessage.error(e.response.data.message);
            }
        },
        async resetPasswordFromAdmin({commit}, setTenant) {
            try {
                const response = await api.resetPasswordFromAdmin(setTenant)
                ElMessage.success(response.message)
            } catch (e) {
                ElMessage.error('Error resetting setTenant password.');
            }
        },
        async createTenants({dispatch, commit}, data) {
            try {
                commit('setLoading', true)
                commit('hasErrors', false)
                await api.createTenant(data);
                ElMessage.success({
                    'message': 'Tenant added successfully.'
                })
                commit('setLoading', false)
            } catch (e) {
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error({
                    'message': 'Error creating Tenant'
                })
                commit('setLoading', false)
            }
        },
        async editTenant({dispatch, commit}, data) {
            try {
                commit('setLoading', true);
                const response = await api.editTenant(data);
                dispatch('getTenant', response.data.id);
                ElMessage.success('Information updated successfully.');
                commit('setLoading', false);
                commit('hasErrors', false)
            } catch (e) {
                commit('setLoading', false);
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error(e.response.data.message);
            }
        },

        async getTenantTpsDashboardSummary({commit}) {
            try {
                const response = await api.getTenantTpsDashboardSummary()
                commit('setTenantTpsDashboardSummary', response.data)
            } catch (e) {
                ElMessage.error("There was an issue getting setTenant tps dashboard summary");
            }
        },
        async getTenantTenancies({commit}) {
            try {
                const response = await api.getTenantTenancies()
                commit('setTenantTenancies', response.data)
            } catch (e) {
                ElMessage.error("There was an issue getting setTenant tenancies");
            }
        },

        async exportTenantsReport({commit}, {filters, format}) {
            try {
                commit('setLoading', true);
                let fileName = new Date().toISOString().slice(0, 10).replaceAll("-", "_") + "_" + new Date().toLocaleTimeString();
                const response = await api.exportTenantsReport({...filters, format});
                const url = window.URL.createObjectURL(new Blob([response]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'Tenants_Report_' + fileName + '.' + format);
                document.body.appendChild(link);
                link.click();
                commit('setLoading', false);
            } catch (e) {
                commit('setLoading', false);
                if (e.response.status === 422) {
                    ElMessage.error("Whoops! You have insufficient permissions to perform this action.");
                } else {
                    ElMessage.error(e.response.data.message);
                }
            }
        },

    }
}
